
/** HELPERS */
export function getShortDateDisplay(date) {
  const options = { weekday: 'short', month: 'short', day: 'numeric' };
  return date.toLocaleDateString('en-US', options); // e.g. "Sun, Jun 14"
}

export function getDateValue(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}




// CREATE One SpankBank
export async function createOneSpankBank(uId, token, spank) {
  // return response.json() if create is successful, else throws error.
  console.log('*** starting createOneSpankBank(spank) ***', spank);

  // build the REST API Call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/spankbank.json?auth=${token}`, {
    method: 'POST',
    body: JSON.stringify(spank)
  });
  // response
  const responseData = await response.json();
  if (!response.ok) {
    throw new Error(response.message || 'Failed to add a new SpankBank memory');
  } else {
    // return true;
    return responseData;
  }


}


// READ ALL SpankBanks
export async function readAllSpankBankMemories(uId, token) {
  // this function returns an object, or throw error

  console.log('*** starting readAllSpankBankMemories() ***');

  // API Call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/spankbank.json?auth=${token}`);

  // error handling
  if (!response.ok) {
    throw new Error(response.message || "Failed to get all SpankBanks");
  }

  // return the data
  return response.json();
}


// UPDATE One SpankBank
export async function updateOneSpankBank(uId, token, spankId, spank) {
  // return {name: id} if update is successful, or throw error.

  console.log('*** starting updateOneSpankBank(spankId, spank) ***', spankId, spank);

  // api call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/spankbank/${spankId}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify(spank)
  });

  // response
  if (!response.ok) {
    throw new Error(response.message || 'Failed to update a SpankBank');
  } else {
    return response.json();
  }

}


// DELETE One SpankBank
export async function deleteOneSpankBank(uId, token, spankId) {
  // returns nothing if delete is successful, or throws error.

  console.log('*** starting deleteOneSpankBank(spankId) ***', spankId);

  // API call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/spankbank/${spankId}.json?auth=${token}`, {
    method: 'DELETE',
  });

  // response
  const responseData = await response.json();
  if (!response.ok) {
    throw new Error(response.message || 'Failed to delete a SpankBank');
  } else {
    return responseData;
  }
}

